<script setup>
    import { ref } from 'vue';
    import CusPopup from './cusPopup.vue';

    defineOptions({
        inheritAttrs: false
    });

    const showBoo = defineModel('showBoo', {
        type: Boolean,
        default: false
    });

    const popupRef = ref(null);
    const $emits = defineEmits(['close', 'confirm', 'cancel']);

    /**
     * 处理关闭事件
     * 关闭弹窗并触发 close 事件
     * @param {...any} args - 传递给父组件的参数
     */
    const handleClose = (...args) => {
        showBoo.value = false;
        $emits('close', ...args);
    };
    /**
     * 处理确认事件
     * 触发 confirm 事件
     * @param {...any} args - 传递给父组件的参数
     */

    const handleConfirm = (...args) => {
        $emits('confirm', ...args);
    };

    /**
     * 处理取消事件
     * 关闭弹窗并触发 cancel 事件
     * @param {...any} args - 传递给父组件的参数
     */
    const handleCancel = (...args) => {
        showBoo.value = false;
        $emits('cancel', ...args);
    };
    /**
     * 打开弹窗
     * 打开弹窗并设置 showBoo 为 true
     */
    const openModal = () => {
        if (showBoo.value) {
            popupRef.value?.openModal?.();
            return;
        }
        showBoo.value = true;
    };
    /**
     * 关闭弹窗
     * 关闭弹窗并设置 showBoo 为 false
     */

    const closeModal = () => {
        if (popupRef.value?.closeModal) {
            popupRef.value.closeModal();
            return;
        }
        handleClose(false);
    };

    defineExpose({
        openModal,
        closeModal
    });
</script>

<template>
    <CusPopup v-if="showBoo" ref="popupRef" v-bind="$attrs" @close="handleClose" @confirm="handleConfirm" @cancel="handleCancel">
        <slot></slot>
    </CusPopup>
</template>
